<!-- 单项选择题 -->
<template>
    <div class="topic_choice">
        <div class="flex topic_select" :class="topicInfo.showAnalysis ? 'topic_select_none' : ''">
            <!-- <div class="topic_type">{{ topicInfo.questionTypeName }}</div> -->
            <div class="topic_content mar_left_10 flex-1">
                <div class="flex">
                    <div class="mt-8">{{ topicInfo.questionNumber }}.</div>
                    <div class="topic_title" v-html="topicInfo?.questionTitle" v-mathml></div>
                </div>
                <!-- <div class="flex Flexalign mt-15" v-if="getAudioUrl(topicInfo.otherRule)">
                    <div class="mr-10">音频：</div><audio :src="getAudioUrl(topicInfo.otherRule)" controls></audio>
                </div> -->
                <div>
                            <div class="flex" v-for="(item, index) in topicInfo.questionContext?.options" :key="index">
                                <div class="mt-5">{{ item.label }} .</div>
                                <div class="editor_box flex-1" v-html="$Tools.handlerImg(item.content)" v-mathml></div>
                            </div>
                </div>
            </div>
        </div>
        <div class="topic_answer">
            <div class="answer_top flex FlexBetween">
                <div class="flex">
                    参考答案：<span class="correct_value_answer">{{
                        this.getChoiceLabel(
                            topicInfo.questionContext?.answer,
                            topicInfo.questionContext?.options
                        )
                    }}</span>
                </div>
            </div>
            <div class="question_analyze_1">
                <div class="question_analyze mar_top_10">【试题分析】</div>
                <div class="mar_top_10" v-html="$Tools.handlerImg(topicInfo.questionAnalyze)" v-mathml></div>
            </div>
            <div class="question_analyze_2">
                <div class="question_analyze mar_top_10">【解析】</div>
                <div class="mar_top_10" v-html="$Tools.handlerImg(topicInfo.questionExplanation)" v-mathml></div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "GjkcH5Choice",
    props: {
        questionInfo: {},
        videoQuestionInfo: {}
    },

    data() {
        return {
            topicInfo: {
                number: 1,
                topicTitle: "",
                options: [
                    { label: "A", content: "aaaa", selected: false, value: 1 },
                    { label: "B", content: "bbbb", selected: false, value: 2 },
                    { label: "C", content: "cccc", selected: false, value: 3 },
                    { label: "D", content: "dddd", selected: false, value: 4 },
                ],
                selectedValue: [],
                correctValue: 2,
                questionAnalyze: "",
                answerContent: "",
            },
        };
    },
    computed: {
        // 将处理逻辑放到计算属性中
        processedQuestionInfo() {
            if (!this.questionInfo) return null;

            // 深拷贝
            const info = JSON.parse(JSON.stringify(this.questionInfo));

            // 处理 answer
            if (info.questionContext?.answer &&
                typeof info.questionContext.answer === 'string') {
                info.questionContext.answer = info.questionContext.answer.split(",");
            }

            return info;
        }
    },
    watch: {
        processedQuestionInfo: {
            handler(val) {
                if (val) {
                    // 初始化 doAnswer
                    if (this.$Tools.empty(val.doAnswer)) {
                        val.doAnswer = [];
                    }
                    this.topicInfo = val;
                }
            },
            immediate: true,
        }
    },
    // watch: {
    //     questionInfo: {
    //         handler(val) {
    //             if (val) {
    //                 this.topicInfo = val;
    //                 // 多选题答案为数组,将正确答案也变为数组
    //                 if (this.$Tools.empty(this.topicInfo.doAnswer)) {
    //                     this.topicInfo.doAnswer = [];
    //                     if (typeof this.topicInfo.questionContext.answer == 'string') {
    //                         this.topicInfo.questionContext.answer = this.topicInfo.questionContext?.answer?.split(
    //                             ","
    //                         );
    //                     }
    //                 }
    //             }
    //         },
    //         deep: true,
    //         immediate: true,
    //     },
    // },
    mounted() { },

    methods: {
        getAudioUrl(info) {
            let ruleInfo = this.$Tools.jsonDecode(info);
            if (!this.$Tools.empty(ruleInfo)) {
                return ruleInfo.listeningRule?.audioUrl
            }
        },
        getChoiceLabel(value, options) {
            if (!options) return;
            // 多选多个答案拼接
            if (typeof value == 'string') {
                value = value.split(',')
            }
            let label = "";
            options.forEach((item) => {
                value.forEach((sitem) => {
                    if (item.serial == sitem) {
                        label += item.label;
                    }
                });
            });
            return label;
        },
    },
};
</script>

<style lang="scss" scoped>
.topic_select {
    font-size: 12px;

    // min-height: 360px;

    .topic_type {
        // margin-top: 1rem;
        min-width: 45px;
        padding: 0 8px;
        height: 21px;
        background: rgba(0, 199, 88, 0.2);
        border-radius: 4px;
        border: 1px solid #00c758;
        line-height: 21px;
        text-align: center;
        font-size: 12px;
        color: #00c758;
    }

    .topic_content {
        overflow-x: auto;
        overflow-y: clip;

        .topic_title {
            // font-size: 16px;
            color: #242324;
            font-weight: 600;
        }

        .editor_box {
            white-space: normal;
        }
    }
}

.topic_select_none {
    min-height: auto;
}

.bottom_box {
    // position: absolute;
    // left: calc(50% - 60px);
    // bottom: 40px;
    // margin: 0 auto;
    text-align: center;

    .btn_view {
        width: 120px;
        height: 42px;
        background: linear-gradient(90deg, #00d5c2, #00d498);
        border-radius: 21px;
        text-align: center;
        line-height: 42px;
        color: #fff;
        font-size: 18px;
        margin: 0 auto;
    }

    .view_analysis {
        color: #13d6aa;
    }
}

.topic_answer {
    width: 100%;
    font-size: 12px;
    // height: 222px;
    // background: rgba(19, 214, 170, 0.05);
    border-radius: 10px;
    padding: 20px;
    color: #666666;
    box-sizing: border-box;

    .answer_top {
        .correct_value_answer {
            color: RGBA(0, 199, 88, 1);
        }

        .error_value_answer {
            color: RGBA(255, 49, 49, 1);
        }

        .btn_ask {
            width: 64px;
            height: 28px;
            background: linear-gradient(90deg, #00d5c2, #00d498);
            border-radius: 14px;
            line-height: 28px;
            text-align: center;
            color: #fff;
        }
    }

    .question_analyze {
        color: #333333;
        font-weight: 600;
    }
}

:deep(.el-checkbox.el-checkbox--large) {
    display: flex;
    align-items: baseline;
    min-height: 36px;
    height: auto;
}

:deep(.el-checkbox__label) {
    line-height: normal;
}
</style>
